import { render, staticRenderFns } from "./Details.vue?vue&type=template&id=482ea414&scoped=true&"
import script from "./Details.vue?vue&type=script&lang=js&"
export * from "./Details.vue?vue&type=script&lang=js&"
import style0 from "./Details.vue?vue&type=style&index=0&lang=less&"
import style1 from "./Details.vue?vue&type=style&index=1&id=482ea414&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "482ea414",
  null
  
)

export default component.exports